import { render } from "./EditManagerView.vue?vue&type=template&id=7790d454"
import script from "./EditManagerView.vue?vue&type=script&lang=js"
export * from "./EditManagerView.vue?vue&type=script&lang=js"

import exportComponent from "/srv/guestwaiterreportingfront/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__